import React from 'react';
import { View, Platform, ScrollView } from 'react-native';
import { Placeholder, PlaceholderContainer } from 'react-native-loading-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import Card from '@mmt/legacy-commons/Common/Components/Card';
const dummyLoaderPromise = new Promise(() => {});

const placeholderBg = '#f1f1f1';

const Gradient = () => (
  <LinearGradient
    colors={[placeholderBg, '#f3f3f3', '#d3d3d3', '#f5f5f5']}
    start={{ x: 1.0, y: 0.0 }}
    end={{ x: 0.1, y: 0.1 }}
    style={{
      flex: 1,
    }}
  />
);

const Shimmer = (props) => {
  if (Platform.OS === 'web') {
    const { replace, ...propsWithoutReplace } = props;
    return <div className="placeholder-shimmer" {...propsWithoutReplace} />;
  }
  return <Placeholder {...props} />;
};

const PlaceholderContainerWrapper = Platform.OS === 'web' ? View : PlaceholderContainer;
const classTypes = ['2SGN', 'SLGN', '3AGN', '2AGN', '1AGN'];

const RailsListingLoaderCard = () => (
  <Card
    style={{
      height: 240,
      overflow: 'hidden',
      paddingTop: 16,
      paddingBottom: 10,
      paddingHorizontal: 16,
      marginVertical: 5,
      marginHorizontal: 0,
    }}
  >
    <PlaceholderContainerWrapper
      style={{ flex: 1, flexDirection: 'row', width: '100%' }}
      animatedComponent={<Gradient />}
      duration={1000}
      delay={100}
    >
      <View>
        <View style={{ flexDirection: 'row', paddingVertical: 4, justifyContent: 'space-between' }}>
          <Shimmer
            style={{ height: 16, width: 130, backgroundColor: placeholderBg, borderRadius: 4 }}
            replace
            loader={dummyLoaderPromise}
          />
          <Shimmer
            style={{
              height: 16,
              width: 60,
              backgroundColor: placeholderBg,
              borderRadius: 4,
            }}
            replace
            loader={dummyLoaderPromise}
          />
        </View>
        <View
          style={{
            flexDirection: 'row',
            marginTop: 12,
            paddingVertical: 2,
            justifyContent: 'space-between',
          }}
        >
          <Shimmer
            style={{
              height: 12,
              width: 64,
              backgroundColor: placeholderBg,
              borderRadius: 4,
            }}
            replace
            loader={dummyLoaderPromise}
          />
          <Shimmer
            style={{
              height: 12,
              width: 56,
              backgroundColor: placeholderBg,
              borderRadius: 4,
            }}
            replace
            loader={dummyLoaderPromise}
          />
          <Shimmer
            style={{
              height: 12,
              width: 65,
              backgroundColor: placeholderBg,
              borderRadius: 4,
            }}
            replace
            loader={dummyLoaderPromise}
          />
        </View>
        <View style={{ flexDirection: 'row', marginTop: 10, justifyContent: 'space-between' }}>
          <Shimmer
            style={{
              height: 16,
              width: 130,
              backgroundColor: placeholderBg,
              borderRadius: 4,
            }}
            replace
            loader={dummyLoaderPromise}
          />
          <Shimmer
            style={{
              height: 16,
              width: 130,
              backgroundColor: placeholderBg,
              borderRadius: 4,
            }}
            replace
            loader={dummyLoaderPromise}
          />
        </View>
        <View style={{ marginTop: 10, marginBottom: 16 }}>
          <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
            {classTypes.map((classtype) => (
              <View key={classtype} style={{ marginLeft: 2, marginRight: 8 }}>
                <Shimmer
                  style={{
                    height: 90,
                    width: 150,
                    backgroundColor: placeholderBg,
                    borderRadius: 4,
                  }}
                  replace
                  loader={dummyLoaderPromise}
                />
              </View>
            ))}
          </ScrollView>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 6 }}>
          <Shimmer
            style={{
              height: 12,
              width: 95,
              backgroundColor: placeholderBg,
              borderRadius: 4,
            }}
            replace
            loader={dummyLoaderPromise}
          />
          <Shimmer
            style={{
              height: 12,
              width: 95,
              backgroundColor: placeholderBg,
              borderRadius: 4,
            }}
            replace
            loader={dummyLoaderPromise}
          />
        </View>
      </View>
    </PlaceholderContainerWrapper>
  </Card>
);

const RailsListingLoader = () => (
  <View>
    <RailsListingLoaderCard />
    <RailsListingLoaderCard />
    <RailsListingLoaderCard />
    <RailsListingLoaderCard />
    <RailsListingLoaderCard />
    <RailsListingLoaderCard />
    <RailsListingLoaderCard />
    <RailsListingLoaderCard />
  </View>
);

export const RailsListingLoaderWithHeader = () => (
  <View>
    <RailsListingHeaderLoader />
    <RailsListingLoader />
  </View>
);

export const RailsListingHeaderLoader = () => (
  <Card
    style={{
      height: 53,
      overflow: 'hidden',
      margin: 9,
      marginBottom: 12,
      width: '100%',
      backgroundColor: '#fafafa'
    }}
  >
    <PlaceholderContainerWrapper
      style={{ flex: 1, flexDirection: 'row', width: '100%' }}
      animatedComponent={<Gradient />}
      duration={1000}
      delay={100}
    >
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
        <View style={{ flexDirection: 'row' }}>
          <View
            style={{ height: '100%', width: 48, justifyContent: 'center', alignItems: 'center' }}
          >
            <Shimmer
              style={{
                height: 16,
                width: 16,
                backgroundColor: placeholderBg,
                borderRadius: 4,
              }}
              replace
              loader={dummyLoaderPromise}
            />
          </View>
          <View style={{ height: '100%', justifyContent: 'center', width: 160 }}>
            <Shimmer
              style={{
                height: 14,
                width: 160,
                backgroundColor: placeholderBg,
                borderRadius: 4,
              }}
              replace
              loader={dummyLoaderPromise}
            />
            <View style={{ height: 5 }} />
            <Shimmer
              style={{
                height: 11,
                width: 100,
                backgroundColor: placeholderBg,
                borderRadius: 4,
              }}
              replace
              loader={dummyLoaderPromise}
            />
          </View>
        </View>
        <View
          style={{
            height: '100%',
            width: 60,
            paddingTop: 10,
            paddingHorizontal: 20,
            marginLeft: 'auto',
          }}
        >
          <Shimmer
            style={{
              height: 35,
              width: 20,
              backgroundColor: placeholderBg,
              borderRadius: 4,
            }}
            replace
            loader={dummyLoaderPromise}
          />
        </View>
      </View>
    </PlaceholderContainerWrapper>
  </Card>
);

export default RailsListingLoader;